<template>
<div class="">
  signing in...
</div>
</template>

<script>
import AWS from '@/resources/AWS.js'
export default {
  name: 'SignedIn',
  created() {
    // if (!verification) {
    //   router.push({ name: 'error', params: { message: 'The authentication response did not contain a valid verification state value' } })
    //   return
    // }
    //
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    localStorage.code = code

    AWS.getNewTokens()
      .then(() => {
        let pathToRedirect = localStorage.lastPath
        if (pathToRedirect === null || pathToRedirect === "") {
          pathToRedirect = "/overview"
        }
        // console.log(pathToRedirect);
        // debugger;
        this.$router.push(pathToRedirect);
      })
      .catch(error => {
        console.log(error.response)
      })
  },
}
</script>

<style lang="scss">
@import '../assets/variables.scss';
</style>
